import { render, staticRenderFns } from "./BuildingEditNewsTab.vue?vue&type=template&id=178fd735"
import script from "./BuildingEditNewsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditNewsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports